<div class="placeholder" *ngIf="charcount <= 0">
  {{ placeholder }}
</div>
<div
  #container
  class="editor-container"
  [ngClass]="{
    animate: animate,
    error: !isValid(),
    'simple-menu-prosemirror': simpleMenu,
    'two-liner-prosemirror': twoliner,
  }"></div>
<input
  type="file"
  #image
  name="image"
  (change)="upload$.next($any($event.target).files)"
  accept="'image/*'"
  hidden />
<div
  class="char-limit"
  [ngClass]="{ active: showCharCount, error: !isValid() }">
  <div class="content">
    {{ charcount }}
    <span class="limit">/ {{ characterLimit }}</span>
  </div>
</div>
